import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppService } from '@app/app.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-show-email-dialog',
  imports: [
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './show-email-dialog.component.html',
})
export class ShowEmailDialogComponent implements OnInit {
  loading = signal(true);
  email = signal('');

  randomInterval: number = Math.floor(Math.random() * 1001) + 500

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      url: string;
    },
    private appService: AppService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.appService.get(this.data.url).subscribe({
        next: (response: any) => {
          this.email.set(response.data);
          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
        },
      });
    }, this.randomInterval);
  }

  copyEmail(): void {
    navigator.clipboard.writeText(this.email());
    this.appService.successSnackBar('Email copied to clipboard');
  }
}